import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';

export const Btn = ({
  label,
  color = C.navy,
  text = '#fff',
  onClick,
  sm,
  ghost,
  full,
  disabled,
  danger,
}) => {
  const bg = danger && !ghost ? C.red : ghost ? C.white : disabled ? '#94A3B8' : color;
  const tc = ghost ? (danger ? C.red : color) : text;
  const bd = ghost ? '1px solid ' + (danger ? C.red : color) : '1px solid transparent';
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      style={{
        background: bg,
        color: tc,
        border: bd,
        borderRadius: 9,
        padding: sm ? '7px 11px' : '11px 14px',
        fontSize: sm ? 9.5 : 11,
        fontWeight: 700,
        width: full ? '100%' : 'auto',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.75 : 1,
        // Un libellé long (ou traduit plus long, en allemand…) passe à la
        // ligne dans le bouton au lieu d'en sortir sur un petit écran.
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        lineHeight: 1.25,
        textWrap: 'balance',
        textAlign: 'center',
        letterSpacing: 0.2,
      }}
    >
      {trU(label)}
    </button>
  );
};
